import FullscreenButton from "../buttons/FullscreenButton";
import MuteButton from "../buttons/MuteButton";
import PlayButton from "../buttons/PlayButton";
import SeekButton from "../buttons/SeekButton";
import SettingsButton from "../buttons/SettingsButton";
import { usePlayerControls2 } from "../hooks/PlayerControlsContext";
import { usePlayerControls } from "../hooks/usePlayerControls";
import HandleSeries from "./HandleSeries";
import { PlayerUIProps } from "./PlayerUI";
import SeekSlider from "./SeekSlider";

const BottomSideOfPlayer = ({ videoRef, thumbnail, currentQuality, setQuality, qualities, audioTracks, setAudioTrack, currentAudioTrack }: PlayerUIProps) => {
  const { toggleMute, seek, isMuted, toggleFullScreen, volume, togglePlay, isPlaying, setVolumeLevel } =
    usePlayerControls(videoRef);

  const { setControlsLock } = usePlayerControls2();

  return (
    <div className="space-y-3" onMouseEnter={() => setControlsLock(false)} onMouseLeave={() => setControlsLock(true)}>
      <SeekSlider videoRef={videoRef} thumbnail={thumbnail} />
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4 max-lg:gap-2">
          <PlayButton togglePlay={togglePlay} isPlaying={isPlaying} />
          <SeekButton seek={seek} direction="back" />
          <SeekButton seek={seek} direction="forward" />
          <MuteButton toggleMute={toggleMute} isMuted={isMuted} volume={volume} setVolumeLevel={setVolumeLevel} />
        </div>
        <div className="relative flex gap-6 max-lg:gap-2">
          <HandleSeries />
          <SettingsButton
            videoRef={videoRef}
            qualities={qualities}
            setQuality={setQuality}
            currentQuality={currentQuality}
            audioTracks={audioTracks}
            setAudioTrack={setAudioTrack}
            currentAudioTrack={currentAudioTrack}
          />
          <FullscreenButton toggleFullScreen={toggleFullScreen} />
        </div>
      </div>
    </div>
  );
};

export default BottomSideOfPlayer;
